import styled from 'styled-components/macro'
import { mq, ScreenSize } from 'styles/mq'
import { theme } from 'styles/theme'

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
  justify-content: center;
  padding: 0;
  margin: var(--spacing-md) auto 0;
  max-width: ${ScreenSize.LG / 10}rem;

  ${mq.smallOnly} {
    max-width: 60rem;
  }
`

export const Item = styled.li`
  --border-radius: 2.8rem;
  --spacing: 2rem;

  ${theme.shadow('1rem', 80)};
  list-style: none;
  padding: 0;
  margin: 0 0 1.1rem;
  width: 100%;
  border-radius: var(--border-radius);

  ${mq.medium} {
    width: calc((100% - var(--spacing-sm)) / 2);
  }

  ${mq.large} {
    width: calc((100% - 2 * var(--spacing-sm)) / 3);
  }
  a {
    text-decoration: none;
  }
`

export const Article = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: end;
  margin-bottom: -1.1rem;
  color: white;
  transition: transform 0.3s ${theme.ease.out};
  border-radius: var(--border-radius);
  overflow: hidden;
  aspect-ratio: 1;

  ${mq.medium} {
    ${Item} a:hover &, ${Item} a:focus-visible & {
      transform: translateY(-1rem);
    }
  }
`

export const Image = styled.img`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  --button-border: 4px;

  position: relative;
  padding: 0 calc(4rem + var(--spacing)) 0 var(--spacing);
  hyphens: none;
  text-align: left;
  text-wrap: balance;
  z-index: 0;

  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 150%;
    background: linear-gradient(to top, hsla(314, 77%, 13%, 1), transparent);
    z-index: -1;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: var(--button-border);
    right: var(--button-border);
    width: 4.5rem;
    height: 5rem;
    border-radius: calc(var(--border-radius) - 4px) 3px
      calc(var(--border-radius) - 4px) 3px;
    transition: background-color 0.3s;
    background: white
      url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.7978 12.921L13.3396 19.3792L11.8191 17.8597L16.7621 12.9167L11.8191 7.97375L13.3396 6.46292L19.7978 12.92L19.7978 12.921ZM13.9693 12.921L7.51015 19.3792L5.99072 17.8597L10.9337 12.9167L5.99072 7.97375L7.51015 6.46292L13.9683 12.92L13.9693 12.921Z' fill='%23102C44'/%3E%3C/svg%3E%0A")
      center center no-repeat;
  }

  &:hover::after,
  &:focus-visible::after {
    background-color: ${theme.colors.secondary};
  }
`

export const Title = styled.h3`
  font-family: ${theme.fonts.headings};
  font-weight: bold;
  font-size: ${20 / 18}em;
  line-height: 1.2;
  margin: 0;
  padding: var(--spacing) 0 0;
`

export const Description = styled.p`
  font-size: ${14 / 18}em;
  line-height: 1.4;
  margin: 0;
  padding: 0.8em 0 var(--spacing);
`
